
export const IS_DEV = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
export const HOME_URL = IS_DEV ? 'http://localhost:3000' : window.location.origin;
export const API_URL = IS_DEV ? 'http://localhost:5000/api' : `${window.location.origin}/api`;